module.exports = __webpack_public_path__ + "/bundle/asset/admission4-1-43b211f19c06019cc56741870af17a20.png";